import styled from 'styled-components';

export const StyledYearContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.grey[600]};
`;

export const StyledYearValue = styled.div`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.text.light};
`;

export const StyledIconWrapper = styled.div`
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
